/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UsersFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    firstName?: boolean;
    hasWhatsApp?: boolean;
    lastName?: boolean;
    middleName?: boolean;
    username?: boolean;
    email?: boolean;
    phone?: boolean;
    defaultTenant?: boolean;
    lastLogin?: boolean;
    dateBirth?: boolean;
    dateAdmission?: boolean;
    recognitionDate?: boolean;
    enrollment?: boolean;
    isDefaultEnrollment?: boolean;
    isSystemAccount?: boolean;
    rfc?: boolean;
    curp?: boolean;
    imss?: boolean;
    address?: boolean;
    residence?: boolean;
    departmentName?: boolean;
    photoProfileUrl?: boolean;
    uuid?: boolean;
    companyId?: boolean;
    homeCompanyId?: boolean;
    jobPositionId?: boolean;
    departmentId?: boolean;
    areaId?: boolean;
    jobCategoryId?: boolean;
    processNumber?: boolean;
    businessUnitId?: boolean;
    inactiveReasonId?: boolean;
    cityId?: boolean;
    personalRequisitionId?: boolean;
    vacancyId?: boolean;
    inactivatedOn?: boolean;
    inactivatedBy?: boolean;
    otherInactiveReason?: boolean;
    inactiveComments?: boolean;
    payrollDate?: boolean;
    payrollInactivatedOn?: boolean;
}

